import { Modal, PrimaryButton } from '@systemeio/ui';
import { useGetEmailTemplates } from 'modules/email/hooks/use-get-email-templates';
import React, { useEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import EmailTemplateSelector from './email-template-selector';
interface EmailTemplateSelectorNewEditorModalProps {
  opened: boolean;
  onChoose: (templateId: number) => Promise<void>;
  onClose: () => void;
}
const EmailTemplateSelectorNewEditorModal = ({
  opened,
  onChoose,
  onClose
}: EmailTemplateSelectorNewEditorModalProps) => {
  const [isFetching, setIsFetching] = useState(false);
  const {
    t
  } = useLocoTranslation();
  const [chosenTemplateId, setChosenTemplateId] = useState<number>();
  const {
    templates
  } = useGetEmailTemplates();
  useEffect(() => {
    if (templates) {
      setChosenTemplateId(templates[0].id);
    }
  }, [templates]);
  const submit = async () => {
    if (!chosenTemplateId) return;
    setIsFetching(true);
    try {
      await onChoose(chosenTemplateId);
    } catch {} finally {
      setIsFetching(false);
    }
  };
  return <Modal opened={opened} onClose={onClose} title={t('dashboard.email_template_selector.choose_template_label')} isFetching={isFetching}>
      <EmailTemplateSelector onChange={template => setChosenTemplateId(template)} templateId={chosenTemplateId} templates={templates} />
      <div className="flex justify-center">
        <PrimaryButton isFetching={isFetching} disabled={!chosenTemplateId} width="large" onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        submit();
      }} type="submit">
          {t('global.confirm')}
        </PrimaryButton>
      </div>
    </Modal>;
};
export default EmailTemplateSelectorNewEditorModal;